import { Box, useTheme, useMediaQuery } from "@mui/material";
import IntroSection from "../Components/Homepage/IntroSection";
import ServicesSection from "../Components/Homepage/ServicesSection";
import StatisticSection from "../Components/Homepage/StatisticSection";
import WhyCodingSection from "../Components/Homepage/WhyCodingSection";
import Footer from "../UI/Footer";
import Navbar from "../UI/Navbar";
import { useEffect } from "react";

const Homepage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  useEffect(() => {
    // Add CSS to make sure particles interactions work
    const style = document.createElement("style");
    style.innerHTML = `
      .particles-canvas {
        pointer-events: auto !important;
      }
      #tsparticles {
        pointer-events: auto !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: "black",
      }}
    >
      <Navbar />
      <IntroSection />

      {/* Container for StatisticSection with proper spacing */}
      <Box
        sx={{
          position: "relative",
          // Less margin since StatisticSection now handles its own positioning
          marginBottom: { xs: "150px", sm: "125px", md: "50px", lg: "30px" },
        }}
      >
        <StatisticSection />
      </Box>

      <ServicesSection />

      {/* Add space between sections */}
      <Box sx={{ height: { xs: "50px", sm: "75px", md: "100px" } }} />

      <WhyCodingSection />

      <Footer />
    </Box>
  );
};

export default Homepage;
